<template>
	<div v-if="groupData.groupTeams.length">
		<div class="card border">
			<div class="card-header">
				<h5 class="header-case">STATUS</h5>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col">
						<h6 class="header-case card-header pl-4" style="font-size: 16px">
							Subscription
						</h6>
						<ul class="list-unstyled">
							<li v-for="team in groupData.groupTeams" :key="team.team_id">
								<div class="row align-items-center ml-2 mb-2">
									<div class="col-5">
										<div
											class="custom-control custom-switch align-items-center"
										>
											<input
												type="checkbox"
												class="custom-control-input"
												:id="'team-select-' + team.team_id"
												:value="team.team_id"
												v-model="selectedTeams"
											/>
											<label
												class="custom-control-label"
												:for="'team-select-' + team.team_id"
											>
												<small>{{ team.team_name }}</small>
											</label>
										</div>
									</div>

									<div class="col-6">
										<small>
											<template
												v-if="
													team.subscription_status === 'trial' &&
													isExpired(team.ends_at)
												"
											>
												<strong>
													Trial Until {{ team.trial_ends_at }}</strong
												>
											</template>
											<template
												v-else-if="
													team.subscription_status === 'subscribed'
												"
											>
												<strong
													>Subscription Until {{ team.ends_at }}</strong
												>
											</template>
											<template
												v-else-if="
													team.subscription_status === 'expired' &&
													team.ends_at
												"
											>
												<strong
													>Subscription Expired on
													{{ team.ends_at }}</strong
												>
											</template>
											<template v-else>
												<strong>No Subscription</strong>
											</template>
										</small>
									</div>
								</div>
							</li>
						</ul>
						<div
							v-if="groupData.groupTeams.length"
							class="d-flex justify-content-start align-items-center"
						>
							<div class="d-flex justify-content-start align-items-center">
								<div class="ml-3">
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="subscriptionType"
											id="trial"
											value="trial"
											v-model="subscriptionType"
										/>
										<label class="form-check-label" for="trial">Trial</label>
									</div>
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="subscriptionType"
											id="subscription"
											value="subscription"
											v-model="subscriptionType"
										/>
										<label class="form-check-label" for="subscription"
											>Subscription</label
										>
									</div>
									<div class="d-flex align-items-center">
										<div style="flex-grow: 1">
											<date-picker
												:to-date="subscriptionDate"
												@date-picker-updated="handleDateChange"
											></date-picker>
										</div>
										<button
											class="ml-3 btn btn-primary"
											@click="updateSubscriptions"
										>
											<span>Update</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col">
						<h6 class="header-case card-header pl-4" style="font-size: 16px">
							ClickHint Subscription
						</h6>
						<ul class="list-unstyled">
							<li v-for="team in groupData.groupTeams" :key="team.team_id">
								<div class="row align-items-center ml-2 mb-2">
									<div class="col-5">
										<div
											class="custom-control custom-switch align-items-center"
										>
											<input
												type="checkbox"
												class="custom-control-input"
												:id="'team-clickhint-' + team.team_id"
												:value="team.team_id"
												v-model="selectedTeamsClickhint"
											/>
											<label
												class="custom-control-label"
												:for="'team-clickhint-' + team.team_id"
											>
												<small>{{ team.team_name }}</small>
											</label>
										</div>
									</div>

									<div class="col-7">
										<small>
											<template v-if="team.clickhint_subscription.plan">
												<strong
													>{{
														translatePlanName(
															team.clickhint_subscription.plan,
														)
													}}
													<strong
														v-if="
															!isExpired(
																team.clickhint_subscription.ends_at,
															)
														"
													>
														Until</strong
													></strong
												>
												<strong
													v-if="
														isExpired(
															team.clickhint_subscription.ends_at,
														)
													"
												>
													Expired on
													{{ team.clickhint_subscription.ends_at }}
												</strong>
												<strong v-else>
													{{ team.clickhint_subscription.ends_at }}
												</strong>
											</template>
											<template v-else>
												<strong>No Subscription</strong>
											</template>
										</small>
									</div>
								</div>
							</li>
						</ul>
						<div
							v-if="groupData.groupTeams.length"
							class="d-flex justify-content-start align-items-center"
						>
							<div class="d-flex justify-content-start align-items-center">
								<div class="ml-3">
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="clickhintSubscriptionType"
											id="trial"
											value="trial"
											v-model="clickhintSubscriptionType"
										/>
										<label class="form-check-label" for="trial">Trial</label>
									</div>
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="clickhintSubscriptionType"
											id="subscription"
											value="subscription"
											v-model="clickhintSubscriptionType"
										/>
										<label class="form-check-label" for="subscription"
											>Subscription</label
										>
									</div>
									<div class="d-flex align-items-center">
										<div style="flex-grow: 1">
											<date-picker
												:to-date="clickhintSubscriptionDate"
												@date-picker-updated="handleClickhintDateChange"
											></date-picker>
										</div>
										<button
											class="ml-3 btn btn-primary"
											@click="updateClickhintSubscriptions"
										>
											<span>Update</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col">
						<h6 class="header-case card-header pl-4" style="font-size: 16px">
							Cases Subscription
						</h6>
						<ul class="list-unstyled">
							<li v-for="team in groupData.groupTeams" :key="team.team_id">
								<div class="row align-items-center ml-2 mb-2">
									<div class="col-5">
										<div
											class="custom-control custom-switch align-items-center"
										>
											<input
												type="checkbox"
												class="custom-control-input"
												:id="'team-cases-' + team.team_id"
												:value="team.team_id"
												v-model="selectedTeamsCases"
											/>
											<label
												class="custom-control-label"
												:for="'team-cases-' + team.team_id"
											>
												<small>{{ team.team_name }}</small>
											</label>
										</div>
									</div>

									<div class="col-7">
										<small>
											<template v-if="team.cases_subscription.plan">
												<strong
													>{{
														translatePlanName(
															team.cases_subscription.plan,
														)
													}}
													<strong
														v-if="
															!isExpired(
																team.cases_subscription.ends_at,
															)
														"
													>
														Until</strong
													></strong
												>
												<strong
													v-if="
														isExpired(
															team.cases_subscription.ends_at,
														)
													"
												>
													Expired on
													{{ team.cases_subscription.ends_at }}
												</strong>
												<strong v-else>
													{{ team.cases_subscription.ends_at }}
												</strong>
											</template>
											<template v-else>
												<strong>No Subscription</strong>
											</template>
										</small>
									</div>
								</div>
							</li>
						</ul>
						<div
							v-if="groupData.groupTeams.length"
							class="d-flex justify-content-start align-items-center"
						>
							<div class="d-flex justify-content-start align-items-center">
								<div class="ml-3">
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="casesSubscriptionType"
											id="trial"
											value="trial"
											v-model="casesSubscriptionType"
										/>
										<label class="form-check-label" for="trial">Trial</label>
									</div>
									<div class="form-check form-check-inline">
										<input
											class="form-check-input"
											type="radio"
											name="casesSubscriptionType"
											id="subscription"
											value="subscription"
											v-model="casesSubscriptionType"
										/>
										<label class="form-check-label" for="subscription"
											>Subscription</label
										>
									</div>
									<div class="d-flex align-items-center">
										<div style="flex-grow: 1">
											<date-picker
												:to-date="casesSubscriptionDate"
												@date-picker-updated="handleCasesDateChange"
											></date-picker>
										</div>
										<button
											class="ml-3 btn btn-primary"
											@click="updateCasesSubscriptions"
										>
											<span>Update</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else-if="groupData.groupTeams.length === 0">
		<h6 class="header-case card-header pl-4" style="font-size: 16px">No Teams Added Yet</h6>
	</div>
	<div v-else>
		<div class="loader d-block text-center">
			<p><i class="fas fa-circle-notch fa-spin"></i></p>
			<p>Loading..</p>
		</div>
	</div>
</template>
<script>
import AdministrationMixin from '../AdministrationMixin.vue';
export default {
	mixins: [AdministrationMixin],
	props: {
		groupData: {
			type: Object,
			required: true,
		},
		partner: Object,
	},
	data() {
		return {
			selectedTeams: [],
			subscriptionDate: null,
			subscriptionType: 'trial',
			selectedTeamsClickhint: [],
			clickhintSubscriptionDate: null,
			clickhintSubscriptionType: 'trial',
			selectedTeamsCases: [],
			casesSubscriptionDate: null,
			casesSubscriptionType: 'trial'
		};
	},
	methods: {
		updateSubscriptions() {
			swal(
				{
					title: 'Are you sure?',
					text: 'Do you want to update the subscriptions with the provided details?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Update!',
				},
				(willUpdate) => {
					if (willUpdate) {
						axios
							.post(this.updateTeamsSubscriptionUrl, {
								teamIds: this.selectedTeams,
								subscriptionType: this.subscriptionType,
								subscriptionDate: this.subscriptionDate,
							})
							.then((response) => {
								setTimeout(() => {
									swal(
										'Updated!',
										'ClickHint Subscriptions have been updated successfully.',
										'success',
									);
								}, 200);
								this.$emit('update-triggered', true);
							})
							.catch((error) => {
								setTimeout(() => {
									swal(
										'Failed!',
										'Failed to update ClickHint subscriptions. Please try again.',
										'error',
									);
								}, 200);
							});
					}
				},
			);
		},
		updateClickhintSubscriptions() {
			swal(
				{
					title: 'Are you sure?',
					text: 'Do you want to update the ClickHint subscriptions with the provided details?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Update!',
				},
				(isConfirmed) => {
					if (isConfirmed) {
						axios
							.post(this.updateTeamsClickhintSubscriptionUrl, {
								teamIds: this.selectedTeamsClickhint,
								subscriptionType: this.clickhintSubscriptionType,
								subscriptionDate: this.clickhintSubscriptionDate,
							})
							.then((response) => {
								setTimeout(() => {
									swal(
										'Updated!',
										'ClickHint Subscriptions have been updated successfully.',
										'success',
									);
								}, 200);
								this.$emit('update-triggered', true);
							})
							.catch((error) => {
								setTimeout(() => {
									swal(
										'Failed!',
										'Failed to update ClickHint subscriptions. Please try again.',
										'error',
									);
								}, 200);
							});
					}
				},
			);
		},
		updateCasesSubscriptions() {
			swal(
				{
					title: 'Are you sure?',
					text: 'Do you want to update the cases subscriptions with the provided details?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Update!',
				},
				(isConfirmed) => {
					if (isConfirmed) {
						axios
							.post(this.updateTeamsCasesSubscriptionUrl, {
								teamIds: this.selectedTeamsCases,
								subscriptionType: this.casesSubscriptionType,
								subscriptionDate: this.casesSubscriptionDate,
							})
							.then((response) => {
								setTimeout(() => {
									swal(
										'Updated!',
										'Cases Subscriptions have been updated successfully.',
										'success',
									);
								}, 200);
								this.$emit('update-triggered', true);
							})
							.catch((error) => {
								setTimeout(() => {
									swal(
										'Failed!',
										'Failed to update cases subscriptions. Please try again.',
										'error',
									);
								}, 200);
							});
					}
				},
			);
		},
		isExpired(dateStr) {
			const today = new Date();
			const endDate = new Date(dateStr);
			return endDate < today;
		},
		translatePlanName(planName) {
			switch (planName) {
				case 'clickhint-pro':
					return 'Subscription';
				case 'free':
					return 'Trial';
				default:
					return this.labelizeGeneral(planName);
			}
		},
		handleDateChange(dateStr) {
			this.subscriptionDate = dateStr;
		},
		handleClickhintDateChange(dateStr) {
			this.clickhintSubscriptionDate = dateStr;
		},
		handleCasesDateChange(dateStr) {
			this.casesSubscriptionDate = dateStr;
		},
	},
};
</script>
